<template>
  <div>
    <!-- <div class="back-btn" @click.stop="goBack">
      <img class="arrow" src="@/assets/images/common/back-arrow.png" alt="" />
      返回
    </div> -->
    <img v-if="backTxt === 'home'" @click.stop="goBack('home')" src="@/assets/images/common/icon-back2.png"
         class="icon-back" alt="">
    <img v-else @click.stop="goBack" src="@/assets/images/common/ic_back.png" class="icon-back" alt="">
  </div>
</template>

<script>
export default {
  name: 'BasePage',
  props: {
    backTxt: ''
  },
  computed: {},
  methods: {
    goBack(type) {
      if (type === 'home') {
        this.$router.replace('/home')
        return
      }
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/home')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.back-btn {
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 99999;
  top: 75%;
  right: 0;
  transform: translateY(-50%);
  width: 53px;
  height: 37px;
  padding-left: 10px;
  background: #EB1700;
  border-radius: 19px 0 0 19px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;

  .arrow {
    margin-right: 6px;
    width: 8px;
    height: 13px;
  }
}

.icon-back {
  position: fixed;
  z-index: 1000;
  right: 20px;
  bottom: 200px;
  width: 40px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/person/components/returnBack.vue